import {AlertType} from "../../../interfaces/IAlert";
<template>
  <v-layout class="lookup-images-container">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" sm="10" md="9" lg="8" class="py-0">
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-card-title>Medios de pago</v-card-title>
                <v-card-subtitle
                  ><span class="font-weight-medium"
                    >Si contrata planes pagos</span
                  >, se abonarán con los siguientes medios pago</v-card-subtitle
                >
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="8" lg="6" class="py-0">
                      <h3 class="font-weight-medium black--text mb-2">
                        Mis tarjetas
                      </h3>
                      <div
                        class="card-list-item d-flex justify-space-between align-center mb-2"
                        v-for="data of paymentDatas"
                        :key="data.id"
                      >
                        <v-icon v-if="cardIcons[data.cardType]">{{
                          cardIcons[data.cardType]
                        }}</v-icon>
                        <span class="card--number"
                          >************{{ data.cardLast }}</span
                        >
                        <v-spacer />
                        <span
                          >{{ padNumber(data.cardExpireMonth, 2) }}/{{
                            data.cardExpireYear.toString().substring(2, 4)
                          }}</span
                        >
                        <v-spacer />
                        <v-btn icon
                          ><v-icon color="grey" @click="deleteCard(data)"
                            >mdi-delete</v-icon
                          ></v-btn
                        >
                      </div>
                      <v-btn
                        color="success"
                        @click="addCard"
                        block
                        depressed
                        large
                      >
                        <v-icon class="mr-2">mdi-credit-card-plus</v-icon>
                        Nueva tarjeta
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import NewCardModal from '../../modals/NewCardModal.vue';
  import { IUser } from '../../../interfaces/IUser';
  import PaymentDataService from '../../../api/services/paymentData.service';
  import { IPaymentData } from '../../../interfaces/IPaymentData';
  import { padNumber } from '../../../utils';
  import { vueData } from '../../../VueData';
  import { AlertType } from '../../../interfaces/IAlert';

  @Component
  export default class PaymentMethods extends Vue {
    paymentDataService = new PaymentDataService();
    @Prop() user: IUser;
    paymentDatas: IPaymentData[] = null;
    padNumber = padNumber;
    cardIcons = {
      visa: 'pw-visa',
      debvisa: 'pw-visa',
      amex: 'pw-american-express',
      master: 'pw-mastercard',
      maestro: 'pw-maestro',
      diners: 'pw-diners',
      discover: 'pw-discover',
    };

    async created() {
      this.loadPaymentData();
    }

    async loadPaymentData() {
      const data = await this.paymentDataService.getAll();
      this.paymentDatas = data;
    }

    addCard() {
      this.$modal.show(
        NewCardModal,
        {
          user: this.user,
        },
        {
          classes: ['vm--modal--overflow', 'vm--modal--transparent'],
          adaptive: true,
          height: 'auto',
          scrollable: true,
          width: 680,
          maxWidth: window.innerWidth * 0.95,
          clickToClose: false,
        },
        {
          created: () => {
            this.loadPaymentData();
          },
        }
      );
    }

    async deleteCard(data: IPaymentData) {
      const res = await vueData.showConfirmDialog(
        this.$modal,
        '¿Está seguro?',
        'Esta acción no se puede deshacer.',
        'Entiendo, quitar de todos modos'
      );
      if (!res) return;

      try {
        await this.paymentDataService.delete(data);
        this.loadPaymentData();
      } catch (e) {
        vueData.addAlert('Error al borrar la tarjeta', AlertType.Error);
      }
    }
  }
</script>
